var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5013 18.9587H7.5013C2.9763 18.9587 1.04297 17.0253 1.04297 12.5003V7.50033C1.04297 2.97533 2.9763 1.04199 7.5013 1.04199H12.5013C17.0263 1.04199 18.9596 2.97533 18.9596 7.50033V12.5003C18.9596 17.0253 17.0263 18.9587 12.5013 18.9587ZM7.5013 2.29199C3.65964 2.29199 2.29297 3.65866 2.29297 7.50033V12.5003C2.29297 16.342 3.65964 17.7087 7.5013 17.7087H12.5013C16.343 17.7087 17.7096 16.342 17.7096 12.5003V7.50033C17.7096 3.65866 16.343 2.29199 12.5013 2.29199H7.5013Z",
    fill: "#4B5563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5846 14.8584H13.043C12.7013 14.8584 12.418 14.5751 12.418 14.2334C12.418 13.8917 12.7013 13.6084 13.043 13.6084H14.5846C14.9263 13.6084 15.2096 13.8917 15.2096 14.2334C15.2096 14.5751 14.9263 14.8584 14.5846 14.8584Z",
    fill: "#4B5563"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8096 14.8584H5.41797C5.0763 14.8584 4.79297 14.5751 4.79297 14.2334C4.79297 13.8917 5.0763 13.6084 5.41797 13.6084H10.8096C11.1513 13.6084 11.4346 13.8917 11.4346 14.2334C11.4346 14.5751 11.1596 14.8584 10.8096 14.8584Z",
    fill: "#4B5563"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5849 11.7246H9.97656C9.6349 11.7246 9.35156 11.4413 9.35156 11.0996C9.35156 10.7579 9.6349 10.4746 9.97656 10.4746H14.5849C14.9266 10.4746 15.2099 10.7579 15.2099 11.0996C15.2099 11.4413 14.9266 11.7246 14.5849 11.7246Z",
    fill: "#4B5563"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7263 11.7246H5.41797C5.0763 11.7246 4.79297 11.4413 4.79297 11.0996C4.79297 10.7579 5.0763 10.4746 5.41797 10.4746H7.7263C8.06797 10.4746 8.3513 10.7579 8.3513 11.0996C8.3513 11.4413 8.06797 11.7246 7.7263 11.7246Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitle);
export default __webpack_public_path__ + "static/media/subtitle.7db0654117f8e0213f75c9839e46e92b.svg";
export { ForwardRef as ReactComponent };